"use strict";
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/~/rxjs/util/isScheduler.js
// module id = ../../../../rxjs/util/isScheduler.js
// module chunks = 5